<template>
  <m-layout-mask>
    <m-layout class="left-sidebar-layout" :class="{ compact: compactSidebar }" style="width: 240px;">
      <!--m-scrollbar :key="isLine + $i18n.locale + this.sports">
        <search /-->
        <!--m-widget-head class="sports-widget-head">
          <template slot="right">
            <span class="but" @click="isLineMenu()" v-bind:class="{ active: isLive }" :key="isLive">{{ $t('menu.live') }}</span>
            <span class="but" @click="isLineMenu()" v-bind:class="{ active: isLine }" :key="isLine">{{ $t('menu.sports') }}</span>
          </template>
        </m-widget-head-->
        <popular-menu v-bind:class="{ hidden: isLive }"/>
        <live-menu v-bind:class="{ hidden: isLine }"/>
        <sports-menu v-bind:class="{ hidden: isLive }"/>
      <!--/m-scrollbar-->
    </m-layout>
    <m-layout grow>
      <div class="live-page">
        <!--div class="live-menu">
          <m-scrollbar>
          <active-button
            v-for="sport in sports"
            :key="sport.id"
            line-color="blue"
            :active="( !$route.params.sport && sport.id == 1 ) || $route.params.sport == sport.id"
            :title="sport.name"
            @click="$router.push(`/home/live/sport/${sport.id}`)"
            class="menu-item"
          >
            <sport-icon-liga-white :name="sport.alias" style="margin-top: -5px;"></sport-icon-liga-white>
            <span class="count-events">{{ sport.events.length }}</span>
            <span>{{ sport.name }}</span>
          </active-button>
          </m-scrollbar>
        </div-->
        <router-view />
      </div>
    </m-layout>
  </m-layout-mask>
</template>

<script>
import IArrow from 'vue-material-design-icons/ChevronLeft'
import IconButton from '@/components/buttons/IconButton'
import ActiveButton from '@/components/buttons/ActiveButton'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MHideToggler from '@/components/buttons/MHideToggler'
import LiveMenu from '@/components/live/menu/Menu'
import SportsMenu from '@/components/sports/menu/Menu'
import PopularMenu from '@/components/sports/menu/Popular'
import Search from '@/components/header/Search'
import { mapState } from 'vuex'

export default {
  components: {
    IArrow,
    IconButton,
    ActiveButton,
    SportIconLigaWhite,
    MLayoutMask,
    MLayout,
    MScrollbar,
    MWidgetHead,
    MHideToggler,
    LiveMenu,
    SportsMenu,
    PopularMenu,
    Search
  },
  data () {
    return {
      compactSidebar: false,
      slider: {
        width: 0,
        margin: 0,
        left: false,
        active: false
      },
      isLine: false,
      isLive: true
    }
  },
  computed: {
    ...mapState({
      sports: state => state.live.menu
    })
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('live/GET_UPCOMING')
    },
    'sports.length' (to, from) {
      let init = () => {
        this.initSlider()
      }
      setTimeout(function () {
        init()
      }, 100)
    }
  },
  mounted () {
    this.initSlider()
  },
  methods: {
    pushEventRoute () {
      let routeSport = this.isActive('view', 'overview') && this.$route.params.sport ? this.$route.params.sport : null
      let { sport, event } = this.$store.getters['live/EVENTVIEW_PARAMS'](routeSport)
      this.$router.push(`/live/sport/${sport}/event/${event}`)
    },
    slide () {
      let step = 80
      let width = document.querySelector('#live-widget-head .slider-content').clientWidth - this.slider.width
      if (this.slider.left) {
        if (Math.abs(this.slider.margin - step) > width) {
          this.slider.margin = -width
        } else {
          this.slider.margin = this.slider.margin - step
        }
        if (Math.abs(this.slider.margin) === width) {
          this.slider.left = !this.slider.left
        }
      } else {
        if (this.slider.margin + step > 0) {
          this.slider.margin = 0
        } else {
          this.slider.margin = this.slider.margin + step
        }
        if (this.slider.margin === 0) {
          this.slider.left = !this.slider.left
        }
      }
    },
    initSlider () {
      let contentWidth = document.querySelector('#live-widget-head .slider-content').clientWidth
      let width = document.querySelector('#live-widget-head').clientWidth - document.querySelector('#live-widget-head .left-widget-head').clientWidth - 100
      width = width - (width % 40)
      this.slider.width = contentWidth > width ? width : contentWidth
      this.slider.active = contentWidth > width
      if (contentWidth > width) {
        this.slider.margin = width - contentWidth
      }
    },
    handleResize () {
      this.initSlider()
    },
    isLineMenu () {
      if (this.isLine) {
        this.isLine = false
        this.isLive = true
      } else {
        this.isLine = true
        this.isLive = false
      }
    }
  }
}
</script>

<style scoped>
.sports-widget-head { margin-left: 10px; }
.live-page { height: 100% }
.live-widget-head { background: #263238; margin: 0 10px; position: relative; z-index: 1; }
.live-widget-head .tabs .active-button { height: 40px; line-height: 40px; padding: 0 10px; }

.slider-container { flex-direction: row-reverse; }
.slider-container .active-button { height: 40px; padding: 8px; width: 40px; line-height: 25px; }
.slider-content-container { flex-direction: row-reverse; height: 40px; overflow: hidden; position: relative; }
.slider-content { -webkit-transition: margin 0.3s; -moz-transition: margin 0.3s; -o-transition: margin 0.3s; transition: margin 0.3s; }

.slider-toggler { width: 40px; }
.slider-toggler-icon { color: #fff; font-size: 24px; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; -o-transition: all 0.3s; transition: all 0.3s; }
.slider-toggler-icon.left { margin-top: 11px; -webkit-transform: rotate(-180deg); -moz-transform: rotate(-180deg); -o-transform: rotate(-180deg); transform: rotate(-180deg); }

.hidden {display: none;}
.active {background: #126e51;}
.but {
  width: 50%;
  text-align: center;
  margin-top: 9px;
  border: 1px solid gray;
  margin-right: 7px;
  line-height: 27px;
  margin-left: -4px;
  cursor: pointer;
}

.live-menu { /* display: flex; */ background: rgba(0,0,0,0.2); }
.menu-item { align-items: center; height: 50px; display: flex; flex-direction: column; flex-shrink: 0; justify-content: center; padding: 0 10px; flex: auto; }
.menu-item .sport-icon-liga-white { margin: 3px 0; }
.count-events { z-index: 1;
    margin-top: -30px;
    position: absolute;
    margin-left: 36px;
    font-weight: 700;
    font-size: 12px; }

</style>



// WEBPACK FOOTER //
// src/components/live/Live.vue